import primaryButtonDisabled from '../../../../../common/algorithms/primary-button-disabled';

const primary = (params) => primaryButtonDisabled(params);

export default primary;
